import { Themes } from '@loadsmart/loadsmart-ui/dist/theming'
import Dropzone from 'react-dropzone'

export interface FileUploaderProps {
  handleUpload: (files: File[]) => void
  accept?: string | string[]
  multiple?: boolean
}

interface FileUploaderState {
  files?: File[]
  url?: string
}

function FileUploader(props: FileUploaderProps) {
  function handleFile(files: File[]) {
    props.handleUpload(files)
  }

  return (
    <Dropzone onDrop={handleFile} multiple={props.multiple}>
      {({ getRootProps, getInputProps, isDragActive, isDragReject }) => (
        <div>
          <div
            {...getRootProps()}
            style={{
              borderStyle: 'dashed',
              borderWidth: '2px',
              borderColor: isDragReject
                ? '#d32f2f'
                : isDragActive
                ? '#1976d2'
                : Themes.Loadsmart['color-accent'],
              padding: '32px',
              borderRadius: '8px',
              textAlign: 'center',
              cursor: 'pointer',
              backgroundColor: isDragActive ? '#e3f2fd' : '#fafafa',
              minHeight: '120px',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              transition: 'all 0.2s ease',
            }}
          >
            <input {...getInputProps()} />
            <p style={{ margin: 0, color: isDragReject ? '#d32f2f' : '#666' }}>
              {isDragReject
                ? 'File type not supported'
                : isDragActive
                ? 'Drop files here...'
                : 'Drag and drop some files here, or click to select files'}
            </p>
          </div>
        </div>
      )}
    </Dropzone>
  )
}

export default FileUploader
